import { render, staticRenderFns } from "./PanelWithVoteEditor.vue?vue&type=template&id=625a17cc&lang=pug&"
import script from "./PanelWithVoteEditor.vue?vue&type=script&lang=ts&"
export * from "./PanelWithVoteEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithVoteEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports